// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7f2a6faf","500":"2954b0a0"}[chunkId] + ".chunk.js";
};